import React from 'react';
import { connect } from 'react-redux';
import { setCoords, initStores } from './../Actions/Booking.action';
import BookingMap from './../Components/BookingMap';
import BookingForm from './../Components/BookingForm';
import { get } from '../Services/http';
import { storeIdConverter } from '../Services/StoreId.service';

const init = async (initStores) => {
  let rawMarkers = await get('/api/stores/GetStores')
    .then(response => response.json())
    .then(result => result
      .filter(({ storeCoordLat, storeCoordLong }) => (!!storeCoordLat || storeCoordLat === 0) && (!!storeCoordLong || storeCoordLong === 0))
      .map(({ storeCoordLat, storeCoordLong, storeId, ...other }, index) => ({
        ...other, storeId: storeIdConverter(storeId).asNumber,
        lat: storeCoordLat, lng: storeCoordLong, storeCoordLat: undefined, storeCoordLong: undefined, index: index + 1
      })));
  initStores(rawMarkers);
}

const BookingContainer = ({ initStores, headerSlotHtml, domainName }) => {
  init(initStores);
  return <>
    <div className="booking__wrapper">
      <div dangerouslySetInnerHTML={{ __html: headerSlotHtml }}></div>
      <BookingForm domainName={domainName} />
    </div>
    <BookingMap />
  </>
};


const mapDispatchToProps = dispatch => ({
  setCoords: (coords) => dispatch(setCoords(coords)),
  initStores: (stores) => dispatch(initStores(stores)),
})
export default connect(null, mapDispatchToProps)(BookingContainer);